import { useHistory } from 'react-router-dom';
import { GAEventNames, GACategoryName, GAActions, GAUniqueEventIds } from '../../helpers/Enums';
import { recordGaEvent } from '../../helpers/GoogleAnalytics';
const BounkirLinks = () => {
    const history = useHistory();

    const recordEvent = (element: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        let { target } = element;
        let anchorElement = target as HTMLAnchorElement;
        let label = anchorElement.textContent !== null ? anchorElement.textContent : "";
        recordGaEvent(GAEventNames.APP_ENGAGMENT, GACategoryName.COMMUNITY_SCREEN, GAActions.CLICK, label, GAUniqueEventIds.APP_ENGAGMENT);
    }

    return (<>
        <div className="links_list_sec">
            <h1 className="links_list_title">קהילת מוטקה</h1>
            <a href="#" onClick={() => history.goBack()} className="meet_close links w-inline-block">
                <img src="/assets/images/ic_back_white.svg" loading="lazy" alt="" />
            </a>
            <ul role="list" className="edit_info_list links w-list-unstyled">
                <li className="edit_info_item links">
                    <a href="https://www.motke.co.il/%D7%9B%D7%9C_%D7%94%D7%A7%D7%91%D7%95%D7%A6%D7%95%D7%AA" onClick={recordEvent} target="_blank" className="motke_link">
                        קבוצות
                    </a>
                </li>
                <li className="edit_info_item links">
                    <a href="https://www.motke.co.il/%D7%99%D7%97%D7%A1%D7%99%D7%9D" onClick={recordEvent} target="_blank" className="motke_link">
                        מגזין
                    </a>
                </li>
                <li className="edit_info_item links">
                    <a href="https://www.motke.co.il/%D7%AA%D7%99%D7%99%D7%A8%D7%95%D7%AA" onClick={recordEvent} target="_blank" className="motke_link">
                        טיולים
                    </a>
                </li>
                <li className="edit_info_item links">
                    <a href="https://www.motke.co.il/%D7%91%D7%99%D7%9C%D7%95%D7%99%D7%99%D7%9D" onClick={recordEvent} target="_blank" className="motke_link">
                        מועדון תרבות
                    </a>
                </li>
                <li className="edit_info_item links">
                    <a href="https://www.motke.co.il/%D7%9B%D7%9C_%D7%94%D7%91%D7%9C%D7%95%D7%92%D7%99%D7%9D" onClick={recordEvent} target="_blank" className="motke_link">
                        בלוגים
                    </a>
                </li>
                <li className="edit_info_item links">
                    <a href="https://www.motke.co.il/%D7%9B%D7%9C_%D7%94%D7%9E%D7%95%D7%93%D7%A2%D7%95%D7%AA" onClick={recordEvent} target="_blank" className="motke_link">
                        לוח מודעות
                    </a>
                </li>
                <li className="edit_info_item links">
                    <a href="https://www.motke.co.il/VOD" onClick={recordEvent} target="_blank" className="motke_link">
                        vod
                    </a>
                </li>
            </ul>
        </div>

    </>)

}

export default BounkirLinks;